import { hasBusinessOutcomeErrorBody } from "common/utils/app-monitoring/business-outcome-error";
import { hasDtfAddValidationErrorBody } from "common/utils/app-monitoring/dtf-add-validation-error";

// Allow-listed 4xx response body shapes that represent deliberate server-side
// control flow / customer-facing validation rather than engineer-actionable
// bugs. Centralizes the per-status predicate chain so `isRelevantBrowserError`
// stays under its function/file line budgets and each new suppression body
// is added in one place.
//
// Callers MUST pass the response body as a string. Pass-through statuses (any
// 4xx not handled here) should continue to notify.
//
// @param {number} status — HTTP status from the response.
// @param {string} body — stringified response body (from `toResponseBodyString`).
// @returns {boolean} — true if the notice should be suppressed.
const isSuppressible4xxBody = (status, body) => {
  if (status === 422 && hasBusinessOutcomeErrorBody(body)) return true;
  if (status === 422 && hasDtfAddValidationErrorBody(body)) return true;
  return false;
};

export default isSuppressible4xxBody;
